import { motion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { staggerContainer, fadeUp } from "@/lib/motion";
import { Phone, Mail } from "lucide-react";

const FOUNDERS = [
  {
    name: "Ayush Singhania",
    role: "Co-Founder",
    qualification: "B. Tech (Mechatronics Engineering)",
    phone: "+91 86382 41548",
    tel: "+918638241548",
    email: "agrotradeglobal25@gmail.com",
  },
  {
    name: "Yash Kumar Harlalka",
    role: "Co-Founder",
    qualification: "B.Com (Hons) \u00b7 MBA, Finance",
    phone: "+91 99868 83199",
    tel: "+919986883199",
    email: "agrotradeglobal25@gmail.com",
  },
];

const BUSINESS_PROFILE = [
  "Agricultural Trading & Export",
  "Authorised Dealers of Ethanol Plants",
  "Specialised Sourcing Agents for DDGS, Animal Feed, Extracts, Oils & Oleoresin companies in India",
];

export const Founders = () => (
  <section
    id="founders"
    data-testid="founders-section"
    className="bg-[#3D2817] py-24 lg:py-40 text-[#F0E6C0]"
  >
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <Reveal className="mb-16 lg:mb-24 max-w-3xl">
        <p className="mb-5 text-xs md:text-sm uppercase tracking-[0.25em] text-[#D8B98A]">
          &#8212; The Partners
        </p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl leading-[0.9] tracking-tight">
          Led by people who
          <span className="italic text-[#E0A96D]"> pick up the phone.</span>
        </h2>
      </Reveal>

      <motion.div
        className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:gap-12"
        variants={staggerContainer}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {FOUNDERS.map((f) => (
          <motion.div
            key={f.name}
            variants={fadeUp}
            data-testid={`founder-card-${f.name.split(" ")[0].toLowerCase()}`}
            className="group flex flex-col justify-between rounded-2xl border border-[#F0E6C0]/25 p-8 lg:p-12 transition-colors duration-500 hover:border-[#E0A96D]"
          >
            <div>
              <span className="font-display text-7xl leading-none text-[#F0E6C0]/20">
                {f.name.split(" ").map((w) => w[0]).join("")}
              </span>
              <h3 className="mt-6 font-display text-4xl tracking-tight">{f.name}</h3>
              <p className="mt-2 text-sm uppercase tracking-[0.2em] text-[#D8B98A]">
                {f.role}
              </p>
              <p className="mt-3 text-sm italic text-[#E6D9A8]/85">
                {f.qualification}
              </p>
            </div>
            <div className="mt-10 space-y-4">
              <a
                href={`tel:${f.tel}`}
                data-testid={`founder-phone-${f.name.split(" ")[0].toLowerCase()}`}
                className="flex items-center gap-4 text-[#E6D9A8] transition-colors hover:text-[#F0E6C0]"
              >
                <Phone size={18} className="text-[#E0A96D]" />
                <span className="text-lg">{f.phone}</span>
              </a>
              <a
                href={`mailto:${f.email}`}
                className="flex items-center gap-4 text-[#E6D9A8] transition-colors hover:text-[#F0E6C0]"
              >
                <Mail size={18} className="text-[#E0A96D]" />
                <span className="text-lg break-all">{f.email}</span>
              </a>
            </div>
          </motion.div>
        ))}
      </motion.div>

      <Reveal className="mt-16 lg:mt-24">
        <div className="rounded-2xl border border-[#F0E6C0]/25 p-8 lg:p-12">
          <p className="text-xs uppercase tracking-[0.25em] text-[#D8B98A]">
            &#8212; Business Profile
          </p>
          <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3">
            {BUSINESS_PROFILE.map((line, i) => (
              <div
                key={i}
                data-testid={`business-profile-${i}`}
                className="flex flex-col gap-3 border-t border-[#F0E6C0]/15 pt-6 md:border-t-0 md:border-l md:pl-6 md:pt-0 md:first:border-l-0 md:first:pl-0"
              >
                <span className="font-display text-3xl text-[#E0A96D]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="text-base leading-relaxed text-[#F0E6C0]">
                  {line}
                </p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
